import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import Select from "react-select";
import SelectCustomStyles from '../../../../../utils/styles/reactSelect';
import { get } from '../../../../../utils/helpers/api';
import { useTranslation } from 'react-i18next';

const EMPTY_FILTERS = {
  keyword: '',
  location: '',
  host_id: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});
  const [employeesData, setEmployeesData] = useState([]);
  const [initLoading, setInitLoading] = useState(true);

  useEffect(() => {
    initData();
  }, [isOpen]);

  const initData = async () => {
    setInitLoading(true);
    const data = await get('/crm/meetings/create');
    if (data.success) {
      setEmployeesData(data.employees);
      setInitLoading(false);
    }
  };
  
  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return(
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={400}
      enableOverlay={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.keyword')}: </Label>
          <Input
            value={filtersData.keyword}
            onChange={(e) => setFiltersData({...filtersData, keyword: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.location')}: </Label>
          <Input
            type="select"
            value={filtersData.location}
            onChange={(e) => setFiltersData({...filtersData, location: e.target.value})}
          >
            <option value="">{t('common.selectLocation')}</option>
            <option value="in_office">{t('common.inOffice')}</option>
            <option value="client_office">{t('sales.clientOffice')}</option>
            <option value="online">{t('common.online')}</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label>{t('crm.host')} </Label>
          <Select
            options={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname }))}
            styles={SelectCustomStyles}
            value={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname })).find(o => o.value === filtersData.host_id) || null}
            onChange={selected => setFiltersData({ ...filtersData, host_id: selected ? selected.value : null })}
          />
        </FormGroup>

        <hr />

        <FormGroup>
          <Label>{t('common.addedAfter')} </Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')} </Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.applyFilters')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.clearFilters')}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;